import { Link } from "react-router-dom";
import { patientProfilePath } from "../lib/patientRecordId";

/** Links to a patient profile only when a real id exists. Never emits /pacientes/undefined. */
export default function PatientRecordLink({ record, className, children, testId }) {
  const href = patientProfilePath(record);
  if (!href) {
    return (
      <div className={className} data-testid={testId || "patient-record-unlinked"}>
        {children}
      </div>
    );
  }
  return (
    <Link to={href} className={className} data-testid={testId}>
      {children}
    </Link>
  );
}
